module.exports = __webpack_public_path__ + "static/media/MX.0eb7fa9d.svg";